import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TeamResource } from 'dy-frontend-http-repository/lib/modules/Team/resources';

import domain from './domain';
import { resetTeams } from './events';

// Get list of teams
export const $teams = domain.createStore<CollectionResource<TeamResource, {}> | null>(null).reset(resetTeams);
